import MailerModal from './components/MailerModal'
import ClipboardModal from './components/ClipboardModal'

new Vue({
    el: '#app',
    components: {MailerModal, ClipboardModal},
    methods: {
        showMailerModal() {
            this.$refs['mailerModal'].showModal();
        },
        showClipboardModal() {
            this.$refs['clipboardModal'].showModal();
        }
    }
})